import React, { Component } from 'react';
import {
  Col,
  Card,
  CardHeader,
  CardBody,
  CardText
} from 'reactstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle } from '@fortawesome/free-regular-svg-icons';

class InsightCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isHovered: null
    };
  }

  handleClick() {
    const { id } = this.props;

    window.location.href = "/core_insights/insight/" + id;
  }

  handleMouseEnter() {
    this.setState({ isHovered: true }); 
  }

  handleMouseLeave() {
    this.setState({ isHovered: false }); 
  }

  render() {
    if(this.props.header) {
      return (
        <Col md="4" className="mb-3">
          <Card
            className={`insight-card ${this.state.isHovered ? "border-secondary h-100" : "border-primary h-100"}`}
            onMouseEnter={this.handleMouseEnter.bind(this)}
            onMouseLeave={this.handleMouseLeave.bind(this)}
            onClick={this.handleClick.bind(this)}>
            <CardHeader
              className={this.state.isHovered ? "bg-secondary text-white" : "bg-primary text-white"}>
              <h3>
                <span className="fa-layers fa-fw mr-3">
                  <FontAwesomeIcon icon={faCircle} transform="grow-10" />
                  <FontAwesomeIcon icon={this.props.icon} transform="shrink-4" />
                </span>
                {this.props.name}
              </h3>
            </CardHeader>
            <CardBody>
              <CardText>{this.props.content}</CardText>
            </CardBody>
          </Card>
        </Col>
      ); 
    } else {
      return (
        <Col md="3" className="mb-3">
          <Card
            className={`insight-card ${this.state.isHovered ? "border-secondary h-100" : "border-primary h-100"}`}
            onMouseEnter={this.handleMouseEnter.bind(this)}
            onMouseLeave={this.handleMouseLeave.bind(this)}
            onClick={this.handleClick.bind(this)}>
            <CardHeader
              className={this.state.isHovered ? "bg-secondary text-white" : "bg-primary text-white"}>
              <span>
                <span className="fa-layers fa-fw mr-2">
                  <FontAwesomeIcon icon={faCircle} transform="grow-10" />
                  <FontAwesomeIcon icon={this.props.icon} transform="shrink-4" />
                </span>
                {this.props.type}
              </span>
              <br/>
              <h5 className="mt-2">{this.props.name}</h5>
            </CardHeader>
            <CardBody>
              <CardText>{this.props.content}</CardText>
            </CardBody>
          </Card>
        </Col>
      ); 
    }
  }
}

export default InsightCard;
